import { S as Swiper } from './swiper-core-PnKJBlxA.js';
import { N as Navigation } from './navigation-qS4ZoLN1.js';
import { A as A11y } from './a11y-Dw_0tDap.js';

class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();

    this.recentlyViewedProducts = JSON.parse(
      localStorage.getItem('recentlyViewedProducts') || '[]'
    );

    this.swiperElement = this.querySelector('[data-swiper]');
    this.swiperWrapper = this.querySelector('.swiper-wrapper');
    this.dataOptions = JSON.parse(this.swiperElement?.dataset?.options || '{}');
  }

  async connectedCallback() {
    if (this.recentlyViewedProducts.length <= 0) return;

    // Wait for the product cards to be fetched before initializing the swiper
    await this.fetchProductCards();
    this.initSwiper();
    this.classList.remove('hidden');
  }

  async fetchProductCards() {
    try {
      this.fetchPromises = this.recentlyViewedProducts.map(async (url) => {
        const response = await fetch(`${url}?view=card`);
        const product = await response.text();

        const html = new DOMParser().parseFromString(product, 'text/html');
        const swiperSlide = html.querySelector('.product-card');

        // Create a HTML node from <div class="swiper-slide">${swiperSlide}</div>
        const slide = document.createElement('div');
        slide.className = 'swiper-slide';
        slide.appendChild(swiperSlide);

        this.swiperWrapper.appendChild(slide);
      });

      await Promise.all(this.fetchPromises);
    } catch (error) {
      console.error('Error fetching product details:', error);
    }
  }

  initSwiper() {
    const productCount = this.recentlyViewedProducts.length;

    this.swiperInstance = new Swiper(this.swiperElement, {
      modules: [A11y, Navigation],
      threshold: 10,
      slidesPerView: 2,
      centeredSlides: true,
      centeredSlidesBounds: true,
      centerInsufficientSlides: true,
      spaceBetween: 16,
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 24,
          centeredSlides: productCount <= 3,
          centeredSlidesBounds: productCount <= 3,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 24,
          centeredSlides: productCount <= 4,
          centeredSlidesBounds: productCount <= 4,
        },
      },
      ...this.dataOptions,
    });
  }
}

if (!customElements.get('recently-viewed-products')) {
  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}
